import types from "./types";

const INITIAL_STATE = {
    deals: [],
    columnToSort: "transactionDate",
    sortDirection: "desc",
    listingModal: {
        isOpen: false,
    },
    dealsPage: 1,
    dealsSort: null,
    dealsFilter: null,
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.RECEIVE_DEALS:
            return Object.assign({}, state, {
                deals: {
                    ...state.deals,
                    [action.tab]: action.deals,
                },
            });
        case types.SWITCH_DEAL_VIEW:
            return Object.assign({}, state, {
                dealView: action.dealView,
            });
        case types.CHECKBOX_CLICK:
            return Object.assign({}, state, {
                selected: action.selected,
            });
        case types.CLEAR_DEALS_STATE:
            return {
                ...state,
                deals: {},
            };
        case types.SET_DEALS_PAGE:
            return {
                ...state,
                dealsPage: action.dealsPage,
            };
        case types.SET_DEALS_SORT:
            return {
                ...state,
                dealsSort: action.dealsSort,
            };
        case types.SET_DEALS_FILTER:
            return {
                ...state,
                dealsFilter: action.dealsFilter,
            };
        case "RESET_STATE":
            return INITIAL_STATE;
        default:
            return state;
    }
};
